<template>
  <p class="info-box" :class="{'info-box--slim': slim}">
    <span v-if="icon" class="icon" :class="`icon--${icon}`" />
    <span class="info-box__content">
      <strong v-if="strongText">{{ strongText }}</strong>
      <span v-if="text" class="info-box__text" :class="{'info-box__text--secondary': strongText}">
        {{ text }}
      </span>
    </span>
  </p>
</template>

<script setup lang="ts">
defineProps<{
  text?: string;
  strongText?: string;
  slim: boolean;
  icon?: string;
}>();
</script>
